import React from 'react';
import { connect } from 'react-redux';
import { branch, compose, renderNothing } from 'recompose';
import { UserService } from '../../../../services/user-service';
import { THeadline } from '../../../../components/template';
import { insertVarIntoString } from '../../../../helpers/insert-var-into-string';
import { ConfigService } from '../../../../services/config-service';
import styles from '../../../../styles/pages/account/account-info.module.scss';

export const AccountInfoComponent = React.memo(({ email }) => {
  const {
    title = 'Logged in as',
    // eslint-disable-next-line no-template-curly-in-string
    subTitle = '${email}'
  } = ConfigService.get('ACCOUNT.MAIN.accountInfo', {});

  return <THeadline className={styles.container} title={title} subtitle={insertVarIntoString(subTitle, { email })} />;
});

const mapStateToProps = ({ account }) => ({ email: account.email });

export const AccountInfo = compose(
  connect(mapStateToProps),
  branch(({ email }) => UserService.hasAccount() || !email, renderNothing)
)(AccountInfoComponent);
